<template>
    <div class="video-uploader">
        <!-- 上传区域 -->
        <div class="upload-area" :style="videolink ? { width: '120px', height: '120px' } : {}" @click="handleUploadAreaClick">
            <!-- 初始状态：十字图标 -->
            <div v-if="!videolink" class="upload-icon">
                <i class="el-icon-plus"></i>
            </div>

            <!-- 视频预览 -->
            <video v-if="videolink" ref="videoPlayer" :src="videolink" controls :style="{ width: '100%', height: '100%', objectFit: 'cover' }"></video>
        </div>

        <!-- 重新上传按钮 -->
        <el-button v-if="videolink" type="text" class="reupload-button" @click="handleReupload">
            重新上传
        </el-button>

        <!-- 隐藏的 input -->
        <input ref="fileInput" type="file" accept=".mp4,.m4v" style="display: none" @change="handleFileChange" />
    </div>
</template>

<script>
import { uploadOSSRequest, getAliyunOssToken } from "@/api/common";
export default {
    name: "VideoUploader",
    data() {
        return {
            videolink: "",
            maxSize: 20,
        };
    },
    props: {
        video_url: {
            type: String,
            default: "",
        },
        type: {
            type: Number,
            default: 0,
        },
        id: {
            type: Number,
            default: 0,
        },
    },
    watch: {
        video_url: {
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    // 视频已上传，自动播放
                    this.videolink = newVal;
                }
            },
        },
    },
    mounted() {
        // 监听 video_url 的变化
        this.$watch("video_url", (newVal) => {
            if (newVal) {
                // 视频已上传，自动播放
                this.videolink = newVal;
            }

            console.log(this.type, this.videolink, "type");
        });
        console.log(this.type, this.videolink, "type");
    },
    methods: {
        // 点击上传区域
        handleUploadAreaClick() {
            if (!this.videolink) {
                this.$refs.fileInput.click(); // 触发文件选择
            }
        },

        // 文件选择后
        handleFileChange(event) {
            const file = event.target.files[0];
            console.log(file, "file", this.type);
            if (this.type == 100) {
                this.maxSize = 100 * 1024 * 1024;
            } else {
                this.maxSize = this.type * 1024 * 1024;
            }
            console.log(this.maxSize, "this.maxSize");

            if (file) {
                // 检查文件类型
                const allowedTypes = ["video/mp4"];
                if (!allowedTypes.includes(file.type)) {
                    this.$message.error("只能上传 MP4 格式");
                    return;
                }
                // 检查文件大小（20M = 20 * 1024 * 1024 bytes）

                /*if (file.size > this.maxSize) {
                    this.$message.error(`文件大小不能超过 ${this.type}M`);
                    return;
                }*/
                this.$emit("uploadvideoduration", {
                    duration: true,
                });
                getAliyunOssToken().then((res) => {
                    uploadOSSRequest(file, res.data).then((fileUrl) => {
                        console.log(fileUrl, "fileUrl");
                        this.$emit("uploadvideoSuccess", {
                            fileUrl,
                            id: this.id,
                        });
                    });
                });
                // 生成视频 URL
                this.videolink = URL.createObjectURL(file);
            }
        },

        // 重新上传
        handleReupload() {
            this.videolink = ""; // 清除视频
            this.$refs.fileInput.value = ""; // 清空 input 的值
            this.$emit("uploadvideoSuccess", {
                fileUrl: "",
            });
        },
    },
};
</script>

<style scoped>
.video-uploader {
    display: flex;
    flex-direction: column;
    /* align-items: center; */
}

.upload-area {
    width: 120px;
    height: 120px;
    border: 2px dashed #ccc;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    overflow: hidden;
}

.upload-icon {
    font-size: 24px;
    color: #999;
}

.reupload-button {
    margin-top: 10px;
    text-align: left;
}
</style>